import get from 'lodash/get';

const validateTemplates = (toValidate, state) => {
	const valid = {};
	Object.keys(state.types).forEach((type) => {
		valid[type] = state.templates.filter((template) => toValidate[type] && toValidate[type].includes(template.id));
	});

	return valid;
};

export default {
	setActiveType(state, payload) {
		state.activeType = payload;
	},

	setActiveTemplate(state, payload) {
		state.activeTemplate = payload;
	},

	filterOptions(state, payload) {
		this._vm.$set(
			state,
			'filterOptions',
			payload.filter((f) => get(f, 'values', []).length)
		);
	},

	setFilter(state, payload) {
		this._vm.$set(state.filters, payload.filter, payload.value);
		if ('tags' === payload.filter && 'gamified' === state.activeType && !payload.value.includes(1)) {
			state.activeType = 'popup';
		}
	},

	appliedFilters(state, payload) {
		state.filters.goals = payload.goals;
		state.filters.categories = payload.categories;
		state.filters.tags = payload.tags;
	},

	clearFilters(state) {
		state.filters.goals = [];
		state.filters.categories = [];
		state.filters.tags = [];
	},

	setSearch(state, payload) {
		if (payload) {
			state.sort = 'recent';
		}
		state.search = payload;
	},

	setSort(state, payload) {
		state.sort = payload;
	},

	setLoadingPreview(state, payload) {
		state.loadingPreview = payload;
	},

	setPreviewing(state, payload) {
		state.previewing = payload;
	},

	apiLoaded(state) {
		state.apiLoaded = true;
	},

	permittedTypes(state, payload) {
		const types = [...payload].map((type) => {
			switch (type) {
				case 'lightbox':
					return 'popup';
				case 'post':
					return 'inline';
				case 'footer':
					return 'floating';
				case 'full-page-takeover':
					return 'fullscreen';
				default:
					return type;
			}
		});
		this._vm.$set(state, 'permittedTypes', types);
	},

	popular(state, payload) {
		this._vm.$set(state, 'popular', validateTemplates({ ...payload }, state));
	},

	recentTemplates(state, payload) {
		this._vm.$set(state, 'recentTemplates', validateTemplates({ ...payload }, state));
	},

	templates(state, payload) {
		this._vm.$set(state, 'templates', [...payload]);
	},
};
